import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authApi } from '@/api/endpoints';
import { useAuthStore } from '@/store/authStore';
import { Alert } from '@/components/common/State';
import { PasswordInput } from '@/components/common/PasswordInput';

export default function LoginPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') ?? '/';
  const login = useAuthStore((s) => s.login);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate(redirect, { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : '로그인에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '40px auto' }}>
      <h1 className="panel-title" style={{ textAlign: 'center' }}>
        로그인
      </h1>

      <div className="card">
        <form className="card__body" onSubmit={handleSubmit}>
          {error && <Alert tone="error">{error}</Alert>}

          <div className="field">
            <label htmlFor="email">이메일</label>
            <input
              id="email"
              type="email"
              className="input"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="password">비밀번호</label>
            <PasswordInput
              id="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="btn btn--primary btn--lg btn--block" disabled={loading}>
            {loading ? '로그인 중…' : '로그인'}
          </button>

          <div style={{ textAlign: 'center', margin: '18px 0 12px' }} className="muted">
            또는 소셜 계정으로 로그인
          </div>

          <div style={{ display: 'grid', gap: 8 }}>
            <a className="btn btn--outline btn--block" href={authApi.socialLoginUrl('google')}>
              Google 로 계속하기
            </a>
            <a
              className="btn btn--block"
              style={{ background: '#03c75a', color: '#fff' }}
              href={authApi.socialLoginUrl('naver')}
            >
              네이버로 계속하기
            </a>
            <a
              className="btn btn--block"
              style={{ background: '#fee500', color: '#191600' }}
              href={authApi.socialLoginUrl('kakao')}
            >
              카카오로 계속하기
            </a>
          </div>

          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14 }}>
            아직 회원이 아니신가요? <Link to="/signup">회원가입</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
